import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-rt-icon-close',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './rt-icon-close.component.html',
  styleUrls: ['./rt-icon-close.component.scss']
})
export class RtIconCloseComponent {
  @Input() width: number | string = 14;
  @Input() height: number | string = 14;
}
